/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, LoneIconButton, Mixins, Text } from '@blend/enterprise-components';
import { TypeaheadMultiSelect } from '@components/TypeaheadMultiSelect/TypeaheadMultiSelect';

const styles = StyleSheet.create({
  listWrapper: {
    paddingTop: 8,
    maxWidth: '100%',
  },
  tileWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '3px',
    ...Mixins.border('transparent', 2, 'solid', 'borderLeft'),
    padding: '8px 12px',
    height: '40px',
    ' button': {
      display: 'none',
      flexShrink: 0,
    },
    ':hover': {
      borderColor: BrandColors.PRIMARY_500,
      backgroundColor: BrandColors.NEUTRAL_100,
      ' button': {
        display: 'block',
      },
    },
  },
});

export interface DismissableTileListProps {
  id: string;
  selections: TypeaheadMultiSelect.Selections;
  onSelectionDeletion: (selection: TypeaheadMultiSelect.Suggestion) => void;
}

export const DismissableTileList = ({ id, selections, onSelectionDeletion }: DismissableTileListProps) => {
  const selectionsArray = Object.values(selections || {});

  if (selectionsArray.length) {
    return (
      <div id={`${id}-dismissableTileList`} className={css(styles.listWrapper)}>
        {selectionsArray.map((selection: TypeaheadMultiSelect.Suggestion) => (
          <div key={selection.value} className={css(styles.tileWrapper)} data-it="DismissableTileList-listItem">
            <Text ellipsis>{selection.display}</Text>
            <LoneIconButton
              btnSize="xs"
              isCircle
              icon="close"
              onClick={() => onSelectionDeletion(selection)}
              theme="tertiary"
            />
          </div>
        ))}
      </div>
    );
  }
  return null;
};
